<template>
    <div class="page-role page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">角色管理</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>系统管理</el-breadcrumb-item>
                            <el-breadcrumb-item>角色管理</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
                    <el-button type="primary" class="btn-bg-p" @click="handleRole('add')">添加 <i class="el-icon-plus"></i></el-button>
                    <!-- <el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button> -->
                </el-col>
            </el-row>
            <div class="bd">
                <!-- <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <el-form-item prop="name" label="角色名称：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.name" size="small" placeholder="角色名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="status" label="状态：">
                            <el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in init_data.status_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div> -->
                <div class="table-block content-body">
                    <div ref="contentBody">
						
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;" row-key="icode" default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}" @selection-change="handleSelectionChange">
                            <!-- <el-table-column type="selection" width="60"></el-table-column> -->
                            <!-- <el-table-column prop="icode" width="100" label="icode" align="center"></el-table-column> -->
                            <el-table-column prop="name" align="left" label="角色名称" min-width="150">
                            </el-table-column>
							<el-table-column prop="roleParentKey" width="150" label="roleParentKey" align="center"></el-table-column>
							<el-table-column prop="roleKey" width="150" label="roleKey" align="center"></el-table-column>
							<el-table-column prop="roleTypeText" width="100" label="角色类型" align="center"></el-table-column>
                           <!-- <el-table-column prop="description" align="center" label="描述" width="180">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.description"></my-textEllipsis>
                                </template>
                            </el-table-column> -->
                            <el-table-column  align="center" label="状态" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.enable">{{scope.row.enable==1?'开启':'禁用'}}</span>
                                </template>
                            </el-table-column>
                           <!-- <el-table-column prop="m_time" align="center" label="更新时间" min-width="180">
                            </el-table-column>
                            <el-table-column prop="c_time" align="center" label="创建时间" min-width="180">
                            </el-table-column> -->
                            <el-table-column prop="operating" align="center" label="操作" min-width="140" fixed="right">
                                <template slot-scope="scope">
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleRole('edit',scope.row)">编辑</el-button>
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteRole(scope.row.icode)">删除</el-button>
									 <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleRoleStaff(scope.row)">角色人员管理</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                   <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-export role-dialog" :title="dlg_role.title" :visible.sync="dlg_role.visible" width="900px" @closed="closeRole" :close-on-click-modal="false">
            <el-form ref="formRole" :model="dlg_role.form" label-width="110px" :rules="dlg_role.rules" @submit.native.prevent>
                <el-form-item prop="name" style="margin-top: 15px;" label="角色名称：" :error="dlg_role.error.name">
                    <el-input size="small" v-model="dlg_role.form.name" placeholder='请输入角色名称' clearable></el-input>
                </el-form-item>
				<el-form-item prop="roleKey" style="margin-top: 15px;" label="roleKey：" >
				    <el-input size="small" v-model="dlg_role.form.roleKey" placeholder='请输入roleKey' clearable></el-input>
				</el-form-item>
               <!-- <el-form-item prop="roleParentKey" label="角色父级：">
		
					<el-tree ref="tree" :data="dlg_role.option.data" :props="dlg_role.option.defaultProps" accordion @node-click="handleNodeClick" :node-key="roleKey" :filter-node-method="filterNode" highlight-current :expand-on-click-node="true" :default-expanded-keys="[dlg_role.option.defaultId]">
					  <span class="span-ellipsis" slot-scope="{ node }">
					    <span :title="node.label">{{ node.label }}{{node.code}}</span>
					  </span>
					</el-tree>

                			<Treeselect size="small" :data="dlg_role.option.data" :defaultKey="dlg_role.form.roleParentKey" clearable checkStrictly @getValue="setTreeMenu"></Treeselect>
                	
                </el-form-item> -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item  label="菜单权限：">
                            <div style="padding: 10px;border-radius: 4px;border: 1px solid #DCDFE6;">
                                <!-- <el-checkbox v-model="dlg_role.menuchecked" @change="getMenuAuth"/> 全选/取消 -->
                                <div style="height: 200px;overflow: auto;">
                                    <el-tree
                                            :data="dlg_role.menu.data"
                                            show-checkbox
                                            node-key="code"
                                            ref="menuTree"
                                            :default-expand-all="true"
                                            :default-checked-keys="dlg_role.menu.default_list"
                                            :check-on-click-node="true"
                                            :props="dlg_role.menu.defaultProps">
											
                                    </el-tree>
                                </div>
                            </div>
                        </el-form-item>
                    </el-col>
                   <el-col :span="12">
                        <el-form-item prop="operate_ids" label="角色父级：">
                            <div style="padding: 10px;border-radius: 4px;border: 1px solid #DCDFE6;">
                                <!-- <el-checkbox v-model="dlg_role.optionchecked" @change="getOptionAuth"/> 全选/取消 -->
                                <div style="height: 200px;overflow: auto;">
									<!-- <Treeselect size="small" :data="dlg_role.option.data" :defaultKey="dlg_role.form.roleParentKey" clearable checkStrictly @getValue="setTreeMenu"></Treeselect> -->
									<el-tree
									        :data="dlg_role.option.data"
									        show-checkbox
									        node-key="roleKey"
									        ref="tree"
									        :default-expand-all="true"
									        :default-checked-keys="dlg_role.option.default_list"
									        :check-on-click-node="true"
									        :props="dlg_role.option.defaultProps">
											
									</el-tree>
                                 <!-- <el-tree ref="tree" :data="dlg_role.option.data" :props="dlg_role.option.defaultProps" accordion @node-click="handleNodeClick" node-key="roleKey" :current-node-key="dlg_role.option.defaultId" highlight-current :expand-on-click-node="true" >
								  <span class="span-ellipsis" slot-scope="{ node }">
									<span :title="node.label">{{ node.label }}</span>
								  </span>
								</el-tree> -->
                               </div>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item prop="enable" label="状态：">
                    <el-radio-group v-model="dlg_role.form.enable">
                        <el-radio v-for="(item, index) in dlg_role.init_data.status_list" :key="index" :label="item.id">{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelRole()">取 消</el-button>
                <el-button type="primary" @click="submitRole()" :loading="dlg_role.btn_loading">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
	 import Treeselect from '@/components/selectTree/selectTree.vue'
    export default {
        name: 'usercenter',
		components: { Treeselect },
        data() {
            return {
                drawer: false,
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                //搜索
                form_search:{
                    //id: "",
                    name:"",
                    status: -1
                },
                init_data: {
                    status_list: [
						
					],
                },
                multipleSelection: [],
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 30,
                        total: 130
                    }
                },
                dlg_role:{
                    id:'',
                    visible:false,
                    btn_loading:false,
                    api: '',
                    title:'',
                    hide_upload: false,
                    img_list: [],
                    form:{
                        name:'',
                        roleKey:'',
						roleParentKey:'',
                        enable:1,
                        power:'',
                        showOrder:0,
						icode:'',
                    },
                    error:{
                        name:''
                    },
                    reset_form: {},
                    menuchecked:false,
                    optionchecked:false,
                    init_data:{
                        status_list: [
							{id:1, name: '开启'},{id:0, name: '禁用'}
						]
                    },
                    rules:{
                        name:{required: true, message: '请输入管理员姓名', trigger: ['change','blur']},
						roleKey:{required: true, message: '请输入管理员姓名', trigger: ['change','blur']},
                        enable:{required: true, message: '请选择状态', trigger: ['change','blur']},
						roleParentKey:{required: true, message: '请选择角色父级', trigger: ['change','blur']},
						power:{required: true, message: '请选择权限', trigger: ['change','blur']},
                    },
                    menu:{
                        default_list:[],
                        data: [],
                        defaultProps: {
                            children: 'children',
                            label: 'name',
							
                        }
                    },
                    option:{
                        default_list:[],
                        data: [],
                        defaultProps: {
                            children: 'children',
                            label: 'name',
							// roleKey:'roleKey'
                        },
						defaultId:''
                    },
                }
            }
        },
        created() {
            document.title = '角色管理';
            this.dlg_role.reset_form = Object.assign({}, this.dlg_role.form);
            this.getInitData();
            this.getList();
			
        },
        methods: {
			handleNodeClick(data, node, obj) {
				this.dlg_role.form.roleParentKey=data.roleKey	
				console.log(data, node, obj,"data, node, obj")
			  //点击节点触发,不同层级的level事件不同
			      //可对应界面变化，比如通过v-if控制模块显隐
			        if (node.level === 1) {
			          this.currLevel = 1
			          this.currSignal = node.data
			        } else if (node.level === 2) {
			          this.currLevel = 2
			          this.currChannel = node.data
			        } else if (node.level === 3) {
						console.log(node.level)
					}
			},

			setTreeMenu(key,data){//获取子组件值
			               console.log(key,"roleParentKey")
			               console.log(data,"data菜单")
										this.dlg_role.form.roleParentKey=data.roleKey	
			           },
			
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getInitData(){
                var _this = this;
                this.$client.get('/api/sys/menu/getTreeWithPowerSimpleForAdmin', {}, function(data,msg){
                     _this.dlg_role.menu.data = data;
					
							// _this.dlg_role.menu.data[key] = data[key];
						
                    // _this.dlg_role.menu.default_list = [14,19].concat(data.menu_auth_list);
                    // _this.dlg_role.option.data = data.operate_list;
                    // _this.dlg_role.option.default_list = data.operate_auth_list;
                    _this.body_loading = false;
                }, function(msg){
                    _this.body_loading = false;
                });
            },
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.pageNo = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                var status_list = [{id:-1, name: '全部'}];
                this.$client.get('/api/sys/role/getTreeForAdmin', params, function(res,message,total,totalPages){
                    _this.table_data.list = res;
					_this.dlg_role.option.data=res
                   //  _this.table_data.page_info.page = totalPages;
					 _this.table_data.page_info.total=total
                    // _this.dlg_role.init_data.status_list = res.status_name_list;
                    // _this.init_data.status_list = status_list.concat(res.status_name_list);
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delmultiple(){
                var _this = this;
                var mullist = this.multipleSelection;
                if(mullist.length == 0){
                    _this.$message("请勾选需要删除的角色");
                    return;
                }
                var idList = [];
                for(var i=0;i<mullist.length;i++){
                    idList.push(mullist[i].id);
                }
                var params = {id:idList.join(",")}
                this.$confirm('确定要批量删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/adminrole/delete', params, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },

            handleRole(type,data){
                this.dlg_role.visible = true;
                if(type == 'add'){
                    this.dlg_role.title = '添加角色';
					this.dlg_role.form.icode = '';
                    this.dlg_role.api = '/api/sys/role/save';
                }else{
                    // this.getInitData()
					
                    this.dlg_role.icode= data.icode;
                    this.dlg_role.title = '编辑角色';
					this.dlg_role.form.icode = data.icode;
                    this.dlg_role.form.name = data.name;
                    this.dlg_role.form.roleKey = data.roleKey;
					this.dlg_role.form.roleParentKey=data.roleParentKey;
					this.dlg_role.option.defaultId=data.roleParentKey
					
					//this.dlg_role.option.defaultId.push(data.roleParentKey)
					  
					// this.dlg_role.option.defaultId=data.roleParentKey;
					console.log(this.dlg_role.option.defaultId,"key默认")
					this.dlg_role.form.power=data.power.split(',')
					if(data.power){
						this.dlg_role.menu.default_list=data.power.split(',')
					}
					if(data.roleParentKey){
						this.dlg_role.option.default_list=data.roleParentKey.split(',')
					}
                    this.dlg_role.form.enable = data.enable;
                    this.dlg_role.api = '/api/sys/role/save';
					console.log(this.dlg_role.form,data,"编辑角色")
                }
            },
			handleRoleStaff(data){
				this.$util.goTo('/user/list',{query:{roleId:data.icode}})
			},
            deleteRole(id){
                var _this = this;
                this.$confirm('确定要删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/api/sys/role/delete', {id:id}, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
			cancelRole(){
        this.dlg_role.visible = false;
				this.dlg_role.form.name=''
				this.dlg_role.form.roleKey=''
				this.dlg_role.form.roleParentKey=''
				this.dlg_role.form.enable=1
				this.dlg_role.form.power=''
				this.dlg_role.form.showOrder=0
				this.dlg_role.form.icode=''
			},
            // getMenuAuth(){
            //     if (this.dlg_role.menuchecked) {
            //         //全选
            //         this.$refs.menuTree.setCheckedNodes(this.dlg_role.menu.data);
            //     }else{
            //         //取消选中
            //         this.$refs.menuTree.setCheckedNodes([]);
            //         this.$refs.menuTree.setCheckedKeys(this.dlg_role.menu.default_list);
            //     }
            // },
            // getOptionAuth(){
            //     if (this.dlg_role.optionchecked) {
            //         //全选
            //         this.$refs.optionTree.setCheckedNodes(this.dlg_role.option.data);
            //     }else{
            //         //取消选中
            //         this.$refs.optionTree.setCheckedNodes([]);
            //         this.$refs.optionTree.setCheckedKeys(this.dlg_role.option.default_list);
            //     }
            // },
            submitRole(){
				// var menu_arrtre=this.$refs.tree.getCheckedNodes()
				// console.log(menu_arrtre,menu_arr,this.dlg_role.option.default_list,"已勾选的")
                var menu_arr = this.$util.getCheckedKeys(this.dlg_role.menu.data, this.$refs.menuTree.getCheckedKeys(), 'code');
				// console.log(menu_arr,this.dlg_role.option.default_list,"已勾选的")
               // var operate_arr = this.dlg_role.form.roleParentKey;
                this.dlg_role.form.power = menu_arr.join(",");
               // this.dlg_role.form.roleParentKey = this.dlg_role.form.roleParentKey;
				//console.log(this.dlg_role.form.power,this.dlg_role.form.roleParentKey,"权限")
				var role_arr = this.$util.getCheckedKeys(this.dlg_role.option.data, this.$refs.tree.getCheckedKeys(), 'roleKey');
				if(role_arr.length == 0){
					this.dlg_role.form.roleParentKey=0
				}else{
					this.dlg_role.form.roleParentKey = role_arr.join(",")
				}
				
				console.log(role_arr,this.dlg_role.form.roleParentKey,this.dlg_role.option.default_list,"已勾选的")
                var _this = this;
                _this.$refs['formRole'].validate((valid) => {
                    if (valid) {
                        this.dlg_role.btn_loading = true;
                        this.$client.post(this.dlg_role.api, this.dlg_role.form, function(res,message){
                            //console.log(res)
                            _this.$message(message);
                            _this.getList();
                            _this.dlg_role.btn_loading = false;
                            _this.dlg_role.visible = false;
                        }, function(message){
                            _this.dlg_role.btn_loading = false;
                            if((typeof message)==='object'){
                                for(var key in message){
                                    _this.dlg_role.error[key] = message[key];
                                }
                            }
                        });
                    } else {
                        console.log('error submit!!');
                return false;
            }
            });
            },
            closeRole(){
                this.dlg_role.menu.default_list = [];
                this.dlg_role.option.default_list = [];
                this.$refs.menuTree.setCheckedNodes([]);
                this.$refs.optionTree.setCheckedNodes([]);
                for(var key in this.dlg_role.form){
					
                    this.dlg_role.form[key] = this.dlg_role.reset_form[key];
                }
                this.$nextTick(()=>{
                    this.$refs.formRole.clearValidate();
            })
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
			
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            },
			dlg_role:function(old,val){
				console.log(old,val)
			}
        }
    }
</script>
<style>
    .el-drawer__header{
        margin-bottom: 0;
        padding-bottom: 20px;
        border-bottom: 1px solid #e9e9e9;
    }
    .el-drawer,.el-drawer__header,.el-drawer__header>:first-child{
        outline: none !important;
    }
    .hide-upload .el-upload--picture-card {
        display: none;
    }

    .domain-dialog .el-form-item__label:before,.forward-dialog .el-form-item__label:before{
        display: none;
    }
    .approve-dialog .el-dialog__footer{
        text-align: center;
    }
    .error-dialog .el-dialog__header{
        border-bottom: none;
        padding-top: 25px;
        text-align: center;
    }
	.last-child .el-tree-node__label {
	  color: red !important; /* 设置最后一个子节点的字体颜色 */
	}
</style>
<style scoped>

</style>